import { apiService } from "@/services/api";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setUserFromMe, clearAuthLocal } from "@/features/auth/authSlice";

export const getMe = async () => {
  const res = await apiService.get("/users/me");
  return res;
};

export const useGetMe = ({
  staleTimeMs = 0,
  refetchOnMount,
  refetchOnWindowFocus,
  refetchOnReconnect,
} = {}) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  const query = useQuery({
    queryKey: ["users-me"],
    queryFn: getMe,
    enabled: Boolean(token),
    staleTime: staleTimeMs,
    refetchOnMount,
    refetchOnWindowFocus,
    refetchOnReconnect,
    // React Query default options (in queryClient) will:
    // - refetch on mount when stale
    // - refetch on reconnect when stale
  });

  useEffect(() => {
    if (query.data) {
      dispatch(setUserFromMe(query.data));
    }
  }, [dispatch, query.data]);

  useEffect(() => {
    if (query.isError) {
      const status = query.error?.response?.status;
      if (status === 401) {
        dispatch(clearAuthLocal());
      }
    }
  }, [dispatch, query.error, query.isError]);

  return {
    me: query.data,
    isGettingMe: query.isLoading,
    meError: query.error,
    refreshMe: query.refetch,
    ...query,
  };
};
